const getLabelColor = ({ error, updated, warning, isFocused, }) => {
    if (error)
        return 'danger';
    if (warning)
        return 'warning';
    if (isFocused || updated)
        return 'action';
    return 'grey';
};
const getCaptionColor = ({ error, updated, warning, captionColorOverride, }) => {
    if (captionColorOverride)
        return captionColorOverride;
    if (error)
        return 'danger';
    if (warning)
        return 'warning';
    if (updated)
        return 'action';
    return 'dark';
};
const getCaptionText = ({ error, updated, caption, }) => {
    if (error && typeof error === 'string')
        return error;
    if (updated && typeof updated === 'string')
        return updated;
    return caption;
};
const getTooltipIconColor = ({ error, updated, warning, }) => {
    if (error)
        return 'danger';
    if (warning)
        return 'warning';
    if (updated)
        return 'action';
    return;
};
const getTextColor = ({ readOnly }) => readOnly ? 'grey' : 'dark';
export const getInputTextDecorators = (props) => {
    return {
        labelColor: getLabelColor(props),
        captionColor: getCaptionColor(props),
        captionText: getCaptionText(props),
        tooltipIconColor: getTooltipIconColor(props),
        textColor: getTextColor(props),
    };
};
